var exports = {
  "C9": "NekoSprite.module__neko___YnBFWl",
  "Hm": "NekoSprite.module__heart___YnBFWl",
  "kn": "NekoSprite.module__nekoHeartFloat___YnBFWl",
};

module.exports = exports;
